export function getRandomUniqueNumbers(count, min, max) {
  const numbers: number[] = [];
  while (numbers.length < count) {
    const num: number = Math.floor(Math.random() * (max - min + 1)) + min;
    if (!numbers.includes(num)) {
      numbers.push(num);
    }
  }
  return numbers;
}